import { baseQuery } from '../baseQuery';

type PostInvoiceParams = {
  serviceId: number;
};

export const postEmailServiceInvoice = async ({ serviceId }: PostInvoiceParams) => {
  const { data } = await baseQuery('email-service-invoice', {
    type: 'POST',
    body: {
      job_id: serviceId,
    },
  });

  return data as never[];
};
